import Vue from 'vue';
import App from './App.vue';
import store from './store';
import {router} from './router';
import vuetify from './plugins/vuetify';
import serviceWorkerManager from './services/serviceWorkerManager';

serviceWorkerManager.loadAndRegisterServiceWorker(() => {
    console.log('register service worker callback.');
});

Vue.config.productionTip = false;
// Vue.config.devtools = true;

new Vue({
    router,
    vuetify,
    store,
    render: h => h(App)
}).$mount('#app');
